<div class="flex w-full">
  <ng-lottie class="mx-auto w-261 h-261" [options]="lottieOptions"></ng-lottie>
</div>
